import React, { useEffect, useRef, useState } from "react";

const AboutUs = () => {
  const [isVisible, setIsVisible] = useState(false);
  const aboutUsRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.1, // Trigger when 10% of the component is visible
      }
    );

    if (aboutUsRef.current) {
      observer.observe(aboutUsRef.current);
    }

    return () => {
      if (aboutUsRef.current) {
        observer.unobserve(aboutUsRef.current);
      }
    };
  }, []);

  return (
    <div
      ref={aboutUsRef} // Attach ref to the component for the observer
      className="flex flex-col items-center my-10 px-4 mb-[50px] text-xl lg:text-2xl"
    >
      {/* Inline CSS for animation */}
      <style>{`
        @keyframes slideIn {
          0% {
            transform: scaleX(0);
          }
          100% {
            transform: scaleX(1);
          }
        }
        .hr-slide {
          animation: slideIn 2s forwards;
          transform-origin: left; /* Start from the left */
        }
        .hr-slideTwo {
          animation: slideIn 2s backwards;
          transform-origin: right; /* Start from the left */
        }
        hr {
          width: 100%; /* Ensure the hr takes full width */
        }
      `}</style>

      <div className="flex items-center w-full mb-4">
        <hr
          className={`flex-1 border-gray-500 ${isVisible ? "hr-slide" : ""}`} // Apply animation class if visible
        />
        <h2 id="about" className="mx-4 lg:text-5xl font-bold text-green-600">
          About Us
        </h2>
        <hr
          className={`flex-1 border-gray-500 ${isVisible ? "hr-slideTwo" : ""}`} // Apply animation class if visible
        />
      </div>
      <p className="text-center max-w-2xl mt-4 text-gray-700 text-xl lg:text-2xl">
        Welcome to our pharmacy, where your health is our top priority. We are
        committed to providing high-quality medications and personalized care
        tailored to meet the unique needs of each patient. Our experienced
        pharmacists and dedicated staff work together to ensure you receive the
        best possible service and advice for your health concerns.
      </p>

      <div className="mt-6 text-center">
        <h3 className="text-2xl font-semibold mb-2 text-green-600">
          Our Mission
        </h3>
        <p className="max-w-xl mx-auto text-gray-600">
          Our mission is to enhance the health and well-being of our community
          through exceptional pharmaceutical care and accessible health
          services. We strive to be your trusted partner in health, guiding you
          through every step of your healthcare journey.
        </p>
      </div>

      <div id="services" className="mt-6 text-center">
        <h3 className="text-2xl font-semibold mb-2 text-green-600">
          Our Services
        </h3>
        <ul className="list-disc list-inside max-w-xl mx-auto text-gray-600">
          <li>Comprehensive medication management</li>
          <li>Health screenings and immunizations</li>
          <li>Patient counseling and education</li>
          <li>Compounding services for personalized medications</li>
          <li>24/7 support for medication-related questions</li>
        </ul>
      </div>

      <div className="mt-6 text-center">
        <h3 className="text-2xl font-semibold mb-2 text-green-600">
          Meet Our Team
        </h3>
        <p className="max-w-xl mx-auto text-gray-600">
          Our team consists of highly qualified pharmacists and healthcare
          professionals who are passionate about providing the best care
          possible. Each team member is dedicated to ongoing education to stay
          up-to-date with the latest advancements in pharmacy and health care.
        </p>
      </div>

      <div className="mt-6 text-center">
        <h3 className="text-2xl font-semibold mb-2 text-green-600">
          Community Involvement
        </h3>
        <p className="max-w-xl mx-auto text-gray-600">
          We believe in giving back to our community. Our pharmacy actively
          participates in local health fairs, educational workshops, and
          community service projects. We are proud to partner with local
          organizations to promote health and wellness in our area.
        </p>
      </div>
    </div>
  );
};

export default AboutUs;
